import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { richContentOptions } from "@/components/content-options";
import Image from "next/image";
import Script from "next/script";

const getEntry = (includes, id) => {
  return includes.Entry.find((i) => i.sys.id === id);
};

export default function Content({
  fields,
  sys,
  includes,
  plain = false,
  addItem = null,
  removeItem = null,
  ...rest
}) {
  console.log("Side List", fields, rest);
  const content = documentToReactComponents(fields.intro, richContentOptions);
  if (fields.options && fields.options.card) {
    return (
      <div className="bg-white my-8 relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 pb-4 bg-white rounded-xl shadow-lg">
          <div className="lg:grid lg:grid-cols-3 lg:gap-8">
            <div>
              <h2 className="text-3xl font-extrabold text-gray-900">
                {fields.title}
              </h2>
              <div className="mt-4 text-lg text-gray-500">{content}</div>
              {fields.options.finance && (
                <div className="mt-4 text-lg text-gray-500 flex">
                  <div className="relative flex-1 h-12">
                    <Image
                      src="/images/snap.png"
                      fill
                      alt="Interest Free Payment Plans With Snap Finance"
                      className="object-contain object-center"
                    />
                  </div>
                  <div className="relative flex-1 h-16">
                    <Image
                      src="https://images.ctfassets.net/eo68gvto3q0j/1da65CSGCNNd25E5p5hmf2/16ba128fea2324e25900abe728067ee2/62b32650b223544c209f5eb6__1_.png"
                      fill
                      alt="Interest Free Payment Plans With Klarna"
                      className="object-contain"
                    />
                  </div>
                </div>
              )}
              {fields.options.finance && (
                <div className="mb-4">
                  {/* <Script id={`inlinesn-${rest.entry.sys.id}`}>
                    {`
                  setTimeout(() => {
                    if (snapuk) {
                      snapuk.widgets.productRBP({ 
                        merchantId: ${
                          process.env.NEXT_PUBLIC_SNAP_MERCHANT_ID
                        }, 
                        costOfGoods: ${rest.event.standardPrice / 100}
                      });
                      snapuk.widgets.productBNPL({ 
                        merchantId: ${
                          process.env.NEXT_PUBLIC_SNAP_MERCHANT_ID
                        }, 
                        costOfGoods: ${rest.event.standardPrice / 100}
                      });
                    }
                  }, 5000);
                `}
                  </Script> */}
                </div>
              )}
            </div>
            <div className="mt-12 lg:mt-0 lg:col-span-2">
              <dl className="divide-y">
                {fields.items.map((entry) => {
                  const item = getEntry(includes, entry.sys.id);
                  if (!item) return null;
                  const content = documentToReactComponents(
                    item.fields.text,
                    richContentOptions
                  );
                  return (
                    <div key={item.sys.id} className="py-6 first:pt-0">
                      <dt className="text-lg leading-6 font-medium text-gray-900">
                        {item.fields.title}
                      </dt>
                      <dd className="mt-2 text-base text-gray-500">
                        {content}
                      </dd>
                    </div>
                  );
                })}
              </dl>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white">
      <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:py-20 lg:px-8">
        <div className="lg:grid lg:grid-cols-3 lg:gap-8">
          <div>
            <h2 className="text-3xl font-extrabold text-gray-900">
              {fields.title}
            </h2>
            <div className="mt-4 text-lg text-gray-500">{content}</div>
          </div>
          <div className="mt-12 lg:mt-0 lg:col-span-2">
            <dl className="space-y-12">
              {fields.items.map((entry) => {
                const item = getEntry(includes, entry.sys.id);
                if (!item) return null;
                const content = documentToReactComponents(
                  item.fields.text,
                  richContentOptions
                );
                return (
                  <div key={item.sys.id}>
                    <dt className="text-lg leading-6 font-medium text-gray-900">
                      {item.fields.title}
                    </dt>
                    <dd className="mt-2 text-base text-gray-500">{content}</dd>
                  </div>
                );
              })}
            </dl>
          </div>
        </div>
      </div>
    </div>
  );
}
